<section class="page">
  <div class="container">
    <div class="page-wrapper">
      <div class="page-header">
        <h1 class="page-title">
          {{ data.nome }}
        </h1>
        <div class="page-header__buttons">
          <mat-slide-toggle
            (change)="onSituacaoChange($event)"
            [checked]="data.situacao == 'A' ? true : false"
          >
            Situação:
            {{ data.situacao == "A" ? "Ativo" : "Inativo" }}</mat-slide-toggle
          >
          <button
            mat-raised-button
            color="primary"
            (click)="submit(form)"
            [disabled]="loadingService.active"
          >
            SALVAR
          </button>
          <button mat-stroked-button color="primary" routerLink="/imobiliaria">
            VOLTAR
          </button>
        </div>
      </div>

      <div class="stats">
        <div class="stats-item">
          <h3 class="stats-item__label">
            <i class="fas fa-mouse"></i>
            <span>Clicks</span>
          </h3>
          <h2 class="stats-item__number">
            {{ data._clicks?.toLocaleString() }}
          </h2>
        </div>
        <div class="stats-item">
          <h3 class="stats-item__label">
            <i class="fas fa-phone-alt"></i>
            <span>Contatos</span>
          </h3>
          <h2 class="stats-item__number">
            {{ data._contatos?.toLocaleString() }}
          </h2>
        </div>
      </div>

      <form class="page-form" #form="ngForm">
        <mat-progress-bar
          mode="indeterminate"
          class="page-form-loading"
          *ngIf="!data.id"
        ></mat-progress-bar>
        <div class="page-form-loading-shade" *ngIf="!data.id"></div>

        <mat-tab-group [animationDuration]="'0ms'" class="page-tab-group">
          <mat-tab label="Detalhes do imóvel">
            <div class="wrapper">
              <mat-form-field
                class="page-form-control"
                [class.two-third]="auth.user.tipo === 'C'"
              >
                <mat-label>Nome</mat-label>
                <input
                  matInput
                  placeholder="De um título para o imóvel"
                  [(ngModel)]="data.nome"
                  name="nome"
                  required
                />
              </mat-form-field>
              <mat-form-field
                class="page-form-control"
                [class.third]="auth.user.tipo === 'C'"
                [class.quad]="auth.user.tipo === 'A'"
              >
                <mat-label>Status</mat-label>
                <mat-select [(ngModel)]="data.status" name="status" required>
                  <mat-option
                    *ngFor="let e of empreendimentoStatus"
                    [value]="e.value"
                    >{{ e.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field
                class="page-form-control quad"
                *ngIf="auth.user.tipo === 'A'"
              >
                <mat-label>Entrar em contato</mat-label>
                <mat-select
                  [(ngModel)]="data.entrarEmContato"
                  name="entrarEmContato"
                  required
                >
                  <mat-option value="C">Corretor</mat-option>
                  <mat-option value="I">Imobiliária</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field
                class="page-form-control third"
                *ngIf="auth.user.tipo === 'A'"
              >
                <mat-label>Corretor</mat-label>
                <mat-select
                  name="usuarioImobiliaria"
                  [(ngModel)]="data.usuarioImobiliaria"
                  [disabled]="!data.imobiliaria.id"
                  [compareWith]="usuarioImobiliariaService.compareFn"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [(ngModel)]="searchUsuariosImobiliaria"
                      name="searchUsuariosImobiliaria"
                      placeholderLabel="Pesquise aqui"
                      noEntriesFoundLabel="Nenhum registro encontrado"
                    >
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="
                      let u of usuariosImobiliaria
                        | filter : searchUsuariosImobiliaria : 'nome'
                    "
                    [value]="u"
                  >
                    {{ u.nome }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="page-form-control">
                <mat-label>Descrição</mat-label>
                <textarea
                  matInput
                  rows="6"
                  placeholder="Descreva um pouco o imóvel"
                  [(ngModel)]="data.descricao"
                  name="descricao"
                ></textarea>
              </mat-form-field>
              <mat-form-field class="page-form-control">
                <mat-label>Diferenciais</mat-label>
                <textarea
                  matInput
                  rows="6"
                  placeholder="Informe alguns de seus diferenciais"
                  [(ngModel)]="data.diferenciais"
                  name="diferenciais"
                ></textarea>
              </mat-form-field>
            </div>
          </mat-tab>
          <mat-tab label="Endereço">
            <div class="wrapper">
              <ng-template matStepLabel>Endereço</ng-template>
              <mat-form-field class="page-form-control">
                <mat-label>CEP</mat-label>
                <input
                  matInput
                  type="tel"
                  placeholder="00000-000"
                  [(ngModel)]="data.cep"
                  name="cep"
                  mask="00000-000"
                  (blur)="onBlurCep($event)"
                  required
                />
              </mat-form-field>
              <mat-form-field class="page-form-control half">
                <mat-label>Estado</mat-label>
                <mat-select
                  [(ngModel)]="data.uf"
                  name="uf"
                  (ngModelChange)="onChangeEstado($event)"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [(ngModel)]="searchEstados"
                      name="searchEstados"
                      placeholderLabel="Pesquise aqui"
                      noEntriesFoundLabel="Nenhum registro encontrado"
                    >
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="
                      let e of estados | filter : searchEstados : 'descricao'
                    "
                    [value]="e.sigla"
                  >
                    {{ e.descricao }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="page-form-control half">
                <mat-label>Cidade</mat-label>
                <mat-select [(ngModel)]="data.cidade" name="cidade">
                  <mat-option>
                    <ngx-mat-select-search
                      [(ngModel)]="searchCidades"
                      name="searchCidades"
                      placeholderLabel="Pesquise aqui"
                      noEntriesFoundLabel="Nenhum registro encontrado"
                    >
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="let c of cidades | filter : searchCidades : 'nome'"
                    [value]="c.nome"
                  >
                    {{ c.nome }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="page-form-control half">
                <mat-label>Bairro</mat-label>
                <input
                  matInput
                  [(ngModel)]="data.bairro"
                  name="bairro"
                  required
                />
              </mat-form-field>
              <mat-form-field class="page-form-control half">
                <mat-label>Rua</mat-label>
                <input
                  matInput
                  [(ngModel)]="data.endereco"
                  name="endereco"
                  required
                />
              </mat-form-field>
              <mat-form-field class="page-form-control third">
                <mat-label>Número</mat-label>
                <input
                  matInput
                  type="tel"
                  [(ngModel)]="data.numeroEndereco"
                  name="numeroEndereco"
                  #numeroEnderecoInput
                  (blur)="onNumeroEnderecoBlur($event)"
                />
              </mat-form-field>
              <mat-form-field class="page-form-control two-third">
                <mat-label>Complemento</mat-label>
                <input
                  matInput
                  [(ngModel)]="data.complemento"
                  name="complemento"
                />
              </mat-form-field>
            </div>
            <div class="map-control">
              <app-im-map
                [lat]="data.latitude"
                [lng]="data.longitude"
                *ngIf="data.longitude && data.latitude"
                (event)="getLatLng($event)"
              ></app-im-map>
            </div>
          </mat-tab>
          <mat-tab label="Características">
            <div class="wrapper">
              <mat-form-field appearance="fill" class="page-form-control quad">
                <mat-label>Vagas de garagem</mat-label>
                <input
                  matInput
                  [(ngModel)]="data.numeroBoxGaragem"
                  name="numeroBoxGaragem"
                  type="tel"
                  mask="0*"
                />
                <i matPrefix class="fas fa-car icon-prefix"></i>
              </mat-form-field>
              <mat-form-field appearance="fill" class="page-form-control quad">
                <mat-label>Quartos</mat-label>
                <input
                  matInput
                  [(ngModel)]="data.numeroQuartos"
                  name="numeroQuartos"
                  type="tel"
                  mask="0*"
                />
                <i matPrefix class="fas fa-bed icon-prefix"></i>
              </mat-form-field>
              <mat-form-field appearance="fill" class="page-form-control quad">
                <mat-label>Suítes</mat-label>
                <input
                  matInput
                  [(ngModel)]="data.numeroSuites"
                  name="numeroSuites"
                  type="tel"
                  mask="0*"
                />
                <i matPrefix class="fas fa-bath icon-prefix"></i>
              </mat-form-field>
              <mat-form-field appearance="fill" class="page-form-control quad">
                <mat-label>Banheiros</mat-label>
                <input
                  matInput
                  [(ngModel)]="data.numeroBanheiros"
                  name="numeroBanheiros"
                  type="tel"
                  mask="0*"
                />
                <i matPrefix class="fas fa-shower icon-prefix"></i>
              </mat-form-field>
              <mat-form-field appearance="fill" class="page-form-control quad">
                <mat-label>Terreno</mat-label>
                <input
                  matInput
                  [(ngModel)]="data.tamanhoTerrenoM2"
                  name="tamanhoTerrenoM2"
                  type="tel"
                  currencyMask
                  [options]="{ prefix: '', thousands: '.', decimal: ',' }"
                />
                <i matPrefix class="fas fa-crop-alt icon-prefix"></i>
                <span matSuffix>m²</span>
              </mat-form-field>
              <mat-form-field appearance="fill" class="page-form-control quad">
                <mat-label>Área construída</mat-label>
                <input
                  matInput
                  [(ngModel)]="data.tamanhoAreaConstruidaM2"
                  name="tamanhoAreaConstruidaM2"
                  type="tel"
                  currencyMask
                  [options]="{ prefix: '', thousands: '.', decimal: ',' }"
                />
                <i matPrefix class="fas fa-object-group icon-prefix"></i>
                <span matSuffix>m²</span>
              </mat-form-field>
            </div>
          </mat-tab>
          <mat-tab label="Tipo">
            <div class="wrapper">
              <mat-form-field class="page-form-control quad">
                <mat-label>Tipo</mat-label>
                <mat-select
                  [(ngModel)]="data.tipoEmpreendimento"
                  name="tipoEmpreendimento"
                  (ngModelChange)="onChangeTipoEmpreendimento($event)"
                  [compareWith]="tipoEmpreendimentoService.compareFn"
                  required
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [(ngModel)]="searchTiposEmpreendimento"
                      name="searchTiposEmpreendimento"
                      placeholderLabel="Pesquise aqui"
                      noEntriesFoundLabel="Nenhum registro encontrado"
                    >
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="
                      let t of tiposEmpreendimento
                        | filter : searchTiposEmpreendimento : 'nome'
                    "
                    [value]="t"
                  >
                    {{ t.nome }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="page-form-control quad">
                <mat-label>Subtipo</mat-label>
                <mat-select
                  [(ngModel)]="data.subtipoEmpreendimento"
                  name="subtipoEmpreendimento"
                  required
                  [disabled]="!subtiposEmpreendimento.length"
                  [compareWith]="subtipoEmpreendimentoService.compareFn"
                >
                  <mat-option>
                    <ngx-mat-select-search
                      [(ngModel)]="searchSubtiposEmpreendimento"
                      name="searchSubtiposEmpreendimento"
                      placeholderLabel="Pesquise aqui"
                      noEntriesFoundLabel="Nenhum registro encontrado"
                    >
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option
                    *ngFor="
                      let s of subtiposEmpreendimento
                        | filter : searchSubtiposEmpreendimento : 'nome'
                    "
                    [value]="s"
                  >
                    {{ s.nome }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="page-form-control quad">
                <mat-label>Tipo de oferta</mat-label>
                <mat-select
                  [(ngModel)]="data.tipoOferta"
                  name="tipoOferta"
                  required
                >
                  <mat-option>Selecionar</mat-option>
                  <mat-option
                    *ngFor="let e of empreendimentoTiposOferta"
                    [value]="e.value"
                  >
                    {{ e?.label }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field class="page-form-control quad">
                <mat-label>Estado de uso</mat-label>
                <mat-select
                  [(ngModel)]="data.estadoUso"
                  name="estadoUso"
                  required
                >
                  <mat-option>Selecionar</mat-option>
                  <mat-option value="N">Novo</mat-option>
                  <mat-option value="U">Usada</mat-option>
                  <mat-option value="P">Na planta</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </mat-tab>
          <mat-tab label="Valores">
            <div class="wrapper">
              <mat-form-field class="page-form-control half">
                <mat-label>Valor condomínio</mat-label>
                <input
                  matInput
                  [(ngModel)]="data.valorCondominio"
                  name="valorCondominio"
                  currencyMask
                />
              </mat-form-field>
              <mat-form-field class="page-form-control half">
                <mat-label>Valor</mat-label>
                <input
                  matInput
                  [(ngModel)]="data.valor"
                  name="valor"
                  currencyMask
                  required
                />
              </mat-form-field>
            </div>
          </mat-tab>
          <mat-tab label="Imagens">
            <div class="wrapper">
              <div class="description">
                <i class="fas fa-arrows-alt"></i>
                <span
                  >Arraste as imagens abaixo para ajustar a ordenação
                  delas</span
                >
              </div>
              <div class="description">
                <i class="fas fa-star"></i>
                <span
                  >Marque com a estrela a imagem que você deseja tornar
                  principal. Ela aparecerá na listagem para os demais
                  usuários.</span
                >
              </div>
              <div class="description">
                <i class="fas fa-trash"></i>
                <span
                  >Clique na lixeira caso deseje excluir alguma das imagens
                  abaixo.</span
                >
              </div>
              <ngx-dropzone (change)="onSelect($event)" class="dropzone">
                <ngx-dropzone-label
                  >Arraste e solte aqui suas imagens!</ngx-dropzone-label
                >
                <ngx-dropzone-image-preview
                  ngProjectAs="ngx-dropzone-preview"
                  *ngFor="let f of files"
                  [removable]="true"
                  (removed)="onRemove(f)"
                  [file]="f"
                >
                  <ngx-dropzone-label></ngx-dropzone-label>
                </ngx-dropzone-image-preview>
              </ngx-dropzone>
              <div
                cdkDropList
                class="dropzone-images"
                (cdkDropListDropped)="drop($event)"
              >
                <div
                  class="dropzone-images__item"
                  *ngFor="let img of data.imagens; let i = index"
                  cdkDrag
                >
                  <div class="col col-grow">
                    <a class="image" (click)="modalGallery.showModalGallery(1)">
                      <img
                        [src]="global.imageUrl + img.imagem"
                        [alt]="img.id"
                      />
                    </a>
                    <span>{{ img.nome }}</span>
                  </div>
                  <div class="col buttons">
                    <button
                      class="dropzone-images__fab"
                      (click)="starImage(img)"
                      [style.pointer-events]="
                        img.principal === 'S' ? 'none' : 'auto'
                      "
                    >
                      <i class="far fa-star" *ngIf="img.principal === 'N'"></i>
                      <i class="fas fa-star" *ngIf="img.principal === 'S'"></i>
                    </button>
                    <button
                      class="dropzone-images__fab"
                      (click)="removeImage(img)"
                    >
                      <i class="fas fa-trash"></i>
                    </button>
                  </div>
                  <div class="col">
                    <span class="position">{{ i + 1 }}</span>
                  </div>
                </div>
              </div>
            </div>
          </mat-tab>
          <mat-tab label="Leads">
            <app-im-estatisticas
              [idEmpreendimento]="data.id"
              *ngIf="data.id"
            ></app-im-estatisticas>
          </mat-tab>
        </mat-tab-group>
      </form>
    </div>
  </div>
</section>

<ng-container *ngIf="imagens.length">
  <ks-modal-gallery
    #modalGallery
    [id]="0"
    [modalImages]="imagens"
    (show)="onVisibleIndex($event)"
    [plainGalleryConfig]="plainGalleryGrid"
  >
  </ks-modal-gallery>
</ng-container>
